import { render, staticRenderFns } from "./DoseConfiguration.vue?vue&type=template&id=2f5e59a0&"
import script from "./DoseConfiguration.vue?vue&type=script&lang=js&"
export * from "./DoseConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./DoseConfiguration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports